import { Box } from "@mui/material";

const DotsWaveLoader: React.FC = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                ml: 0.5
            }}
        >
            {[0, 1, 2].map((i) => (
                <Box
                    key={i}
                    sx={{
                        width: 4,
                        height: 4,
                        borderRadius: '50%',
                        bgcolor: '#cbd5e1',
                        animation: 'wave 1.2s infinite',
                        animationDelay: `${i * 0.2}s`,
                        mx: 0.2
                    }}
                />
            ))}
            <style>
                {`
          @keyframes wave {
            0% { transform: scale(1); opacity: 0.6; }
            50% { transform: scale(1.4); opacity: 1; }
            100% { transform: scale(1); opacity: 0.6; }
          }
        `}
            </style>
        </Box>
    )
}

export default DotsWaveLoader;